import React from 'react';
import useDropArea from '../../hooks/use-dnd/use-drop-area';
import type { DropCallback } from '../../stores/types/user-interface';
import { DRAG_TYPE } from '../../stores/reducers/user-interface';

/* we render this when a overlay item is being dragged, it functions as a drop area
on top of the canvas that accepts overlay items */

interface Props {
	dropCallback: DropCallback
}

export default function OverlayDropArea(props: Props) {
	const { dropRef } = useDropArea({
		accepts: DRAG_TYPE.OVERLAY,
		dropCallback: props.dropCallback,
		dropAreaData: {
			id: 'overlay-drop-area',
		},
	});

	return (
		<div
			className="overlay-drop-area"
			id="overlay-drop-area"
			ref={dropRef}
		/>
	);
}
